import { FC, useContext } from 'react';

import { Button, Dropdown, Typography } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

import { useGenerateDataTable } from '../../utils/generate-data-table';

import { StepThreeFormContext } from '../../../../contexts/StepThreeForm';
import { QUOTATION_BUTTON } from '../../../../../../../shared';

import './index.css'

interface HeaderColumnPlanProps {
    planId: string
}

export const HeaderColumnPlan: FC<HeaderColumnPlanProps> = ({planId}) => {

  const { deleteColumn } = useGenerateDataTable();

  const { planSelectedSummary, setPlanSelectedSummary, setLabelButton } = useContext(StepThreeFormContext)

  const onMenuClick = (columnKey: string) => (e: any) => {
    if (e.key === '1') {
      if(planSelectedSummary !== '') {
        setPlanSelectedSummary('');
        setLabelButton(QUOTATION_BUTTON.COTIZAR)
        deleteColumn!(columnKey);
        return
      };
      
      deleteColumn!(columnKey);
    }
  };

  const items = [
    {
      key: '1',
      label: 'Eliminar',
      danger: true,
    },
  ];

  return (
    <div className='header-table-home-button'>
      <Typography.Text strong className='title-column-table-home-quotation'>
        Plan {planId}
      </Typography.Text>
      <Dropdown
        menu={{ items, onClick: onMenuClick(planId) }}
        trigger={['click']}
        arrow
      >
        <Button type='text'>
          <MoreOutlined />
        </Button>
      </Dropdown>
    </div>
  );
};
